import { useTranslation } from "react-i18next";
import {
  useTransferDraft,
  useTransferDraftDispatch,
} from "../../../../providers/transferDraft";
import { TextField } from "@mui/material";
import { TransferDraftActionType } from "../../../../reducers/transferDraft";
import { fixedFieldSx } from "./fixedFieldSx";

type MessageTextFieldProps = {
  disabled?: boolean;
};

export default function MessageTextField({ disabled }: MessageTextFieldProps) {
  const transferDraft = useTransferDraft();
  const transferDraftDispatch = useTransferDraftDispatch();
  const { t } = useTranslation();

  return (
    <TextField
      sx={fixedFieldSx}
      disabled={disabled}
      value={transferDraft.description}
      variant="filled"
      type="text"
      multiline
      label={t(`Message`)}
      minRows={5}
      InputProps={{
        disableUnderline: true,
      }}
      onChange={(newValue) =>
        transferDraftDispatch({
          type: TransferDraftActionType.descriptionUpdate,
          updatedDescription: newValue.target.value,
        })
      }
    />
  );
}
